<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
      document.cookie =
          "SESSION=" + encodeURI("f924ec04-12e1-49a0-855a-b78f510bb22f");
    }
  }
}
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@font-face {
  font-family: 'Douyin Sans-Bold';
  src: url("./assets/font/DouyinSansBold.otf");
  font-weight: bold;
  font-style: normal;
  font-display: swap; /* 字体加载时显示系统字体，字体加载完成后显示自定义字体 */
}

.btn {
  cursor: pointer;
  width: 82px;
  height: 36px;
  background: linear-gradient(134deg, #a05eff 0%, #2852ff);
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: linear-gradient(134deg, #9145ff 0%, #1946ff);
  }
}
</style>
<style lang="less">
  .icon {
    width: 1em; height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
